export default __webpack_public_path__ + "static/media/wise_paas_ensaas.3eb52bbb.svg";